import { mapState, mapActions } from 'vuex'

export const rightPanelMethods = mapActions('rightPanel', [
    'setPanelContent',
    'getPlanList',
])

export const rightPanelComputed = {
    ...mapState('rightPanel', ['panelContent', 'planList']),
}